<template>
  <v-card>
    <v-card-title>
      <slot name="header"></slot>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-container v-if="items.length > 0" fluid>
        <v-row v-for="(classroom, i) in items" :key="i">
          <v-col cols="12" md="4">
            <slot name="schedule" :item="classroom" :index="i">
              <div class="mb-2">
                <v-icon left small>mdi-calendar-today</v-icon>
                <strong>
                  {{ formatDate(classroom.start_date, 'DD MMM YYYY') }} -
                  {{ formatDate(classroom.end_date, 'DD MMM YYYY') }}
                </strong>
              </div>
              <p>
                Class Meetings ({{
                  classroom.subscription_package.class_per_week
                }}
                x
                {{ classroom.subscription_package.minutes_per_class }} mins)
              </p>
              <ul>
                <li
                  v-for="(weeklySchedule, j) in classroom.weekly_schedules"
                  :key="j"
                >
                  {{ dayOfWeekProps(weeklySchedule.day_of_week, 'text') }}
                </li>
              </ul>
            </slot>
          </v-col>
          <v-col cols="12" md="5">
            <h4 class="mb-2">{{ classroom.name }}</h4>
            <p v-if="!isTeacherAccount">
              Teacher: {{ classroom.teacher.name }}
            </p>
            <p>Students:</p>
            <ul>
              <li v-for="(student, j) in classroom.students" :key="j">
                {{ student.name }}
              </li>
            </ul>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" md="3" class="text-right" align-self="center">
            <v-btn
              text
              color="info"
              small
              :href="$route('classrooms.detail', classroom.id)"
            >
              See Details
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
      <div v-else class="text-center">
        <slot name="nodata"></slot>
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  name: 'Classrooms',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
